var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5765 5.84675C11.7909 6.13264 11.733 6.53822 11.4471 6.75263L5.23535 11.4115V7.5291C5.23535 7.17174 5.52505 6.88205 5.88241 6.88205C6.23977 6.88205 6.52947 7.17174 6.52947 7.5291V8.82322L10.6706 5.71734C10.9565 5.50292 11.3621 5.56086 11.5765 5.84675Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82354 1.70623C4.24994 1.70623 1.35296 4.60321 1.35296 8.17682C1.35296 11.7504 4.24994 14.6474 7.82354 14.6474C11.3972 14.6474 14.2941 11.7504 14.2941 8.17682C14.2941 4.60321 11.3972 1.70623 7.82354 1.70623ZM0.0588379 8.17682C0.0588379 3.88849 3.53522 0.412109 7.82354 0.412109C12.1119 0.412109 15.5883 3.88849 15.5883 8.17682C15.5883 12.4651 12.1119 15.9415 7.82354 15.9415C3.53522 15.9415 0.0588379 12.4651 0.0588379 8.17682Z",
    fill: "#FFFFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkRounded);
export default __webpack_public_path__ + "static/media/checkmark-rounded.2d6bebf2ef42473748599556e3800877.svg";
export { ForwardRef as ReactComponent };